<div
  data-testid="local-spinner"
  [class]="classes()"
  [style]="ngStyles()"
  class="tw:absolute tw:inset-0 tw:z-[11000] tw:bg-[url('/assets/images/spinner.gif')] tw:bg-center tw:bg-no-repeat"
></div>
